interface Tab {
	id: number;
	label: string;
}

export const TABS: Tab[] = [{ id: 0, label: 'Job' }, { id: 1, label: 'Job Hazard Assessment' }, { id: 2, label: 'Billing Codes' }, { id: 3, label: 'Attachments' }];
